import Modal from "components/Modal";
import { useEffect } from "react";
import "./HubSpotForm.style.css";
import config from "config";

const HubSpotForm = ({ show, setShow, hideCloseButton = false }) => {
  useEffect(() => {
    if (!show) return;

    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.charset = "utf-8";
    script.async = true;

    script.onload = () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        window.hbspt.forms.create({
          portalId: "7697776",
          formId: "eec7ff60-7295-4503-957b-70019805041e",
          target: "#hubspot-form",
          cssClass: "hubspot-form",
          onFormReady: function ($form) {
            let verticalField: any;

            if (typeof $form.find === "function") {
              verticalField = $form.find('input[name="vertical"]');
            } else if (typeof $form.querySelectorAll === "function") {
              verticalField = $form.querySelectorAll('input[name="vertical"]');
            } else {
              verticalField = [];
            }

            if (verticalField.length) {
              verticalField[0].value = config.PLATFORM_NAME;
              console.log(verticalField[0].value);
            }
          },
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [show]);

  if (!show) return null;

  return (
    <Modal
      isShowing={true}
      showHeader={true}
      showTitle={true}
      title="Contact Us"
      onHide={
        hideCloseButton
          ? undefined
          : () => {
              setShow(false);
            }
      }
      classNames={{
        borderLine: "hidden",
        modalHeader: "grid grid-cols-2 pt-[18px] px-[24px] text-primary",
        closeButtonContainer: "justify-self-end",
        childrenContainer: "p-2",
        popup: "max-w-[700px]",
      }}
    >
      <div className="text-center">
        <p className="text-primary pb-6 mt-[-12px]">
          Reach out to us with your questions, ideas, <br />
          or feedback — our team is here to help!
        </p>
        <div id="hubspot-form"></div>
      </div>
    </Modal>
  );
};

export default HubSpotForm;
